/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'ngf-control-label-container',
    templateUrl: './ngf-control-label-container.component.html',
    styleUrls: ['./ngf-control-label-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NgfControlLabelContainerComponent {

  @Input()
  @HostBinding('class.required')
  required: boolean;

}
